module.exports = __webpack_public_path__ + "static/media/23_B.f8b927ec.png";